import {
  CreditCard as CreditCardIcon,
  Home as HomeIcon,
  Apartment as ApartmentIcon,
  DirectionsCar as CarIcon,
  Work as WorkIcon,
  Smartphone as SmartphoneIcon,
  Person as PersonIcon,
  Store as StoreIcon,
  AccountBalance as AccountBalanceIcon,
  GroupWork as GroupWorkIcon,
} from '@material-ui/icons';
import { ReactComponentElement } from 'react';

const map = {
  CREDIT_CARD: {
    label: 'Tarjeta de crédito',
    pluralLabel: 'Tarjetas de crédito',
    icon: CreditCardIcon,
    iconName: 'credit_card',
  },
  PAYROLL: {
    label: 'Libranza',
    pluralLabel: 'Libranza',
    icon: WorkIcon,
    iconName: 'work',
  },
  PAYROLL_ADVANCE: {
    label: 'Adelanto de nómina',
    pluralLabel: 'Adelanto de nómina',
    icon: WorkIcon,
    iconName: 'work',
  },
  COMMERCIAL_LOAN: {
    label: 'Crédito comercial',
    pluralLabel: 'Créditos comerciales',
    icon: WorkIcon,
    iconName: 'work',
  },
  CONSUMER_LOAN: {
    label: 'Crédito de consumo',
    pluralLabel: 'Créditos de consumo',
    icon: StoreIcon,
    iconName: 'store',
  },
  ALL_PURPOSE: {
    label: 'Libre inversión',
    pluralLabel: 'Libre inversión',
    icon: StoreIcon,
    iconName: 'store',
  },
  MORTGAGE: {
    label: 'Hipotecario',
    pluralLabel: 'Hipotecarios',
    icon: HomeIcon,
    iconName: 'home',
  },
  VEHICLE: {
    label: 'Vehículo',
    pluralLabel: 'Vehículos',
    icon: CarIcon,
    iconName: 'car',
  },
  LEASING: {
    label: 'Leasing',
    pluralLabel: 'Leasing',
    icon: ApartmentIcon,
    iconName: 'apartment',
  },
  REVOLVING: {
    label: 'Rotativo',
    pluralLabel: 'Rotativos',
    icon: AccountBalanceIcon,
    iconName: 'account_balance',
  },
  INFORMAL: {
    label: 'Informal',
    pluralLabel: 'Informales',
    icon: PersonIcon,
    iconName: 'person',
  },
  SERVICES: {
    label: 'Servicios',
    pluralLabel: 'Servicios',
    icon: SmartphoneIcon,
    iconName: 'smartphone',
  },
  VIRTUAL: {
    label: 'Unificación de Deudas',
    pluralLabel: '',
    icon: GroupWorkIcon,
    iconName: 'group_work',
  },
  DEFAULT: {
    label: 'Deuda',
    pluralLabel: 'Deudas',
    icon: AccountBalanceIcon,
    iconName: 'account_balance',
  },
};

export const getDebtConfigByType = (key: string): { label: string, pluralLabel: string, icon: ReactComponentElement<'svg'>, iconName: string } => {
  if (key in map) {
    return {
      ...(map as any)[key],
    };
  }
  return map.DEFAULT as any;
};
